import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/auth";
import RouterLayout from "@/layouts/router";
import AppLayout from "@/layouts/fhb";
import StandardLayout from "@/layouts/standard";
import SessionLayout from "@/layouts/session";
import store from "@/store";
Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: StandardLayout,
      children: [
        {
          path: "/",
          meta: {
            title: "D3rriana Home"
          },
          component: () => import("./views/site/home")
        },
        {
          path: "/thankyou",
          meta: {
            title: "Thank You"
          },
          component: RouterLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Thank You and Photo Shoot"
              },
              component: () => import("./views/site/credits")
            }
          ]
        },
        {
          path: "/memories",
          meta: {
            title: "Memories"
          },
          component: RouterLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Memories"
              },
              component: () => import("./views/site/memories")
            },
            {
              path: "article/:blogTitle",
              meta: {
                title: "Memory"
              },
              component: () => import("./views/site/blog/article")
            }
          ]
        },
        {
          path: "/faves",
          meta: {
            title: "Look at Derriana's Faves"
          },
          component: RouterLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Shop Derriana's Faves"
              },
              component: () => import("./views/site/faves")
            },
            {
              path: ":faveSlug",
              meta: {
                title: "Memory"
              },
              component: () => import("./views/site/faves/faveDetailsPage")
            }
          ]
        },
        {
          path: "/policy",
          meta: {
            title: "Policy"
          },
          component: RouterLayout,
          children: [
            {
              path: "privacy",
              component: () => import("./views/site/policy/privacy")
            },
            {
              path: "terms",
              component: () => import("./views/site/policy/terms")
            },
            {
              path: "data",
              component: () => import("./views/site/policy/data")
            },
            {
              path: "care",
              component: () => import("./views/site/policy/care")
            },
            {
              path: "subscription-services-agreement",
              component: () => import("./views/site/policy/ssa")
            }
          ]
        },
        {
          path: "/blog",
          meta: {
            title: "Blog"
          },
          component: RouterLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog")
            },
            {
              path: "article/:blogTitle",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/article")
            },
            {
              path: "a/:blogTitle",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/article")
            },
            {
              path: "crew",
              meta: {
                title: "Blog Crew"
              },
              component: () => import("./views/site/blog/crew")
            },
            {
              path: "/blog/crew/@:crewName",
              meta: {
                title: "Blog Crew Member"
              },
              component: () => import("./views/site/blog/crew/member")
            },
            {
              path: "list",
              meta: {
                title: "Blog Reading List"
              },
              component: () => import("./views/site/blog/list")
            },
            {
              path: "apply-to-blog",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/apply")
            }
          ]
        },
        {
          path: "/myapp",
          redirect: "/myapps",
          meta: {
            title: "MyApps Home"
          },
          component: RouterLayout,
          children: [
            {
              path: "/myapps",
              meta: {
                title: "MyApps"
              },
              component: () => import("./views/site/myApps")
            },
            {
              path: ":myAppName",
              meta: {
                title: "MyApps Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: "/@:myAppName",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: "/@:myAppName/:heartbeatId",
              meta: {
                title: "Corner Title"
              },
              component: () =>
                import("./views/site/myApps/myAppDisplayHeartbeat")
            },
            {
              path: "c/:myAppName",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              /* resource - pages, crew, */
              path: ":myAppName/:resource",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: ":myAppName/:resource/:resourceItem",
              meta: {
                title: "The Specific Area"
              },
              component: () => import("./views/site/myApps/myApp")
            }
          ]
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/site/system/404")
        },
        {
          path: "/system/500",
          meta: {
            title: "Error 500"
          },
          component: () => import("./views/site/system/500")
        }
      ]
    },
    {
      path: "/app",
      redirect: "/",
      component: AppLayout,
      meta: { authRequired: true, hidden: true },
      children: [
        {
          path: "/sessions",
          redirect: "sessions",
          component: SessionLayout,
          meta: { authRequired: true, hidden: true },
          children: [
            {
              path: "/sessions",
              meta: {
                title: "Sessions"
              },
              component: () => import("./views/app/sessions")
            }
          ]
        },
        {
          path: "/",
          meta: {
            title: "D3rriana"
          },
          component: () => import("./views/app/myapps")
        },
        {
          path: "profile",
          meta: {
            title: "My Profile"
          },
          component: () => import("./views/app/me")
        },
        {
          path: "pricing",
          meta: {
            title: "D3rriana pricingsans"
          },
          component: () => import("./views/site/pricing")
        },
        {
          path: "blog",
          meta: {
            title: "D3rriana Blog"
          },
          component: () => import("./views/site/blog")
        },
        {
          path: "library",
          meta: {
            title: "D3rriana Corners"
          },
          component: () => import("./views/site/myApps")
        },
        {
          path: "/manage",
          redirect: "corner",
          component: RouterLayout,
          children: [
            {
              path: "platform",
              meta: {
                title: "Publishing Platform",
                activeGuideRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/platform")
            },
            {
              path: "blog",
              meta: {
                title: "Blog Management",
                activeBlogRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/blogger")
            },
            {
              path: "admin",
              meta: {
                title: "Admin Management",
                activeAdminRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/admin")
            }
          ]
        },
        {
          path: "/heartbeat",
          redirect: "/restricted",
          meta: {
            title: "My Heartbeats"
          },
          component: RouterLayout,
          async beforeRouteUpdate(to, from) {
            // react to route changes...
            this.userData = await fetchUser(to.params.id);
          },
          children: [
            {
              path: ":heartbeatSlug",
              meta: {
                title: "Heartbeat Title"
              },
              component: () => import("./views/app/heartbeat/index")
            },
            {
              path: "c/:cornerTitle",
              meta: {
                title: "Heartbeat Title"
              },
              component: () => import("./views/app/heartbeat")
            }
          ]
        }
      ]
    },
    {
      path: "/system",
      component: AuthLayout,
      redirect: "/signin",
      children: [
        {
          path: "/signin",
          meta: {
            title: "signin"
          },
          component: () => import("./views/site/signin")
        },
        {
          path: "/signup",
          meta: {
            title: "Sign Up"
          },
          component: () => import("./views/site/signup")
        },
        {
          path: "/forgot-password",
          meta: {
            title: "Forgot Password"
          },
          component: () => import("./views/site/forgotPassword")
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/site/system/404")
        }
      ]
    },
    // Redirect to 404
    {
      path: "*",
      redirect: "system/404",
      hidden: true
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    let isAuthenticated = localStorage.getItem("userData");
    // console.log("isAuthenticated => ", isAuthenticated);
    if (!isAuthenticated) {
      next({
        path: "/signin"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
